import React, { useState } from 'react';
import {  IconButton } from '@material-ui/core'
import api from "../../../common/api";
import { useGlobalState } from '../../../state';
import {version} from '../../../common/enums';
const ImageToStruct = ({handleImageParseError,handleDailyEntryOCRData}) => {
  const [{user}] = useGlobalState();
  const [loading, setLoading] = useState(false);
const handleFileUpload = async (e) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  setLoading(true);

  try {
    // Convert all files to base64
    const base64Images = await Promise.all(
      Array.from(files).map(
        (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64Image = reader.result?.toString().split(',')[1];
              resolve(`data:image/jpeg;base64,${base64Image}`);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          })
      )
    );

    // Build prompt based on version
    let prompt;
    if (user.versionID === version.lite) {
      prompt = `
      Extract the fields in these images as a single valid JSON object only. 
- Merge data across images if needed. 
- Always include all keys shown in the template below, even if values are missing. 
- Use 0 for missing numbers, and "" (empty string) for missing text fields. 
- If data is missing in one image, use values from another image. 
- Return ONLY JSON, with no explanations, no markdown, no code block markers, no comments, no extra characters, no line breaks. 
- Format JSON compactly (all on one line if possible).
      {
          "farm_name": "FARM NAME",
          "farm_id": 0,
          "date": "29/7/2025",
          "sheds": [
            {
              "name": "NAME",
              "shed_id": 0,
              "mortality": 0,
              "eggType": "",  // EGG type column has this data like "CORRECT SIZE (ID:248)" with select options where user user will tick the box([ ]) we should extract the text before (ID:248) and put it in eggType and the number 248 in eggTypeID
              "eggTypeID": 0,  // EGG type column has this data like "CORRECT SIZE (ID:248)" with select options where user user will tick the box([ ]) we should extract the text before (ID:248) and put it in eggType and the number 248 in eggTypeID
              "egg_sales": 0,
              "closing_stock": 0,
              "breakage": 0,
              "damaged": 0,
              "closing_feed": 0,
              "feed_received": 0
            }
          ]
        }`;
    } else if (user.versionID === version.pro) {
      prompt = `Extract the fields in these images as a single valid JSON object only. 
- Merge data across images if needed. 
- Always include all keys shown in the template below, even if values are missing. 
- Use 0 for missing numbers, and "" (empty string) for missing text fields. 
- If data is missing in one image, use values from another image. 
- Return ONLY JSON, with no explanations, no markdown, no code block markers, no comments, no extra characters, no line breaks. 
- Format JSON compactly (all on one line if possible).
        {
          "farm_name": "FARM NAME",
          "farm_id": 0,
          "date": "29/7/2025",
          "sheds": [
            {
              "name": "NAME",
              "shed_id": 0,
              "mortality": 0,
              "eggType": "",  // EGG type column has this data like "CORRECT SIZE (ID:248)" with select options where user user will tick the box([ ]) we should extract the text before (ID:248) and put it in eggType and the number 248 in eggTypeID
              "eggTypeID": 0,  // EGG type column has this data like "CORRECT SIZE (ID:248)" with select options where user user will tick the box([ ]) we should extract the text before (ID:248) and put it in eggType and the number 248 in eggTypeID
              "egg_sales": 0,
              "closing_stock": 0,
              "breakage": 0,
              "damaged": 0,
              "closing_feed": 0,
              "feed_received": 0,
              "feed_cost": 0
            }
          ]
        }`;
    } else {
      prompt = `Extract the fields in these images as a single valid JSON object only. 
- Merge data across images if needed. 
- Always include all keys shown in the template below, even if values are missing. 
- Use 0 for missing numbers, and "" (empty string) for missing text fields. 
- If data is missing in one image, use values from another image. 
- Return ONLY JSON, with no explanations, no markdown, no code block markers, no comments, no extra characters, no line breaks. 
- Format JSON compactly (all on one line if possible).
    {
          "farm_name": "FARM NAME",
          "farm_id": 0,
          "date": "29/7/2025",
          "sheds": [
            {
              "name": "NAME",
              "shed_id": 0,
              "mortality": 0,
              "eggType": "", // EGG type column has this data like "CORRECT SIZE (ID:248)" with select options where user user will tick the box([ ]) we should extract the text before (ID:248) and put it in eggType and the number 248 in eggTypeID
              "eggTypeID": 0,  // EGG type column has this data like "CORRECT SIZE (ID:248)" with select options where user user will tick the box([ ]) we should extract the text before (ID:248) and put it in eggType and the number 248 in eggTypeID
              "egg_sales": 0,
              "closing_stock": 0,
              "breakage": 0,
              "damaged": 0,
              "closing_feed": 0
            }
          ]
        }`;
    }

    // One API call with all images
    const payload = {
      image_urls: base64Images, // 👈 now sending multiple images
      prompt,
    };

    const response = await api.post('/getAImodelResponse', payload);
    let cleanText = response.response || "";

    if (cleanText.startsWith("```json")) {
      cleanText = cleanText.slice(7, -3).trim();
    } else if (cleanText.startsWith("```")) {
      cleanText = cleanText.slice(3, -3).trim();
    }

    let textData = cleanText
      .replace(/\/\*[\s\S]*?\*\//g, "")
      .replace(/\/\/.*$/gm, "")
      .replace(/,\s*(?=[}\]])/g, "")
      .replace(/(\r\n|\n|\r)/gm, "")
      .trim();

    const jsonResponse = JSON.parse(textData);

    if (!jsonResponse?.date) {
      handleImageParseError("Could not extract date from the images. Please ensure they are clear and try again.");
      return;
    }

    handleDailyEntryOCRData(jsonResponse);
  } catch (err) {
    console.error(err);
    handleImageParseError("Failed to process the images. Please try again.");
  } finally {
    setLoading(false);
  }
};
  return (

<div style={{ marginTop: "-10px" }}>
  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
    <IconButton component="span">
      {
        loading ?
          <img
            src={"/images/searchAnimation.gif"}
            alt="upload"
            style={{ width: 50, height: 50,marginTop:"-6px" }}
          />:
          <img
          src={ "/images/searchIcon.png"}
          alt="upload"
          style={{ width: 35, height: 35 }}
        />
      }
    
    </IconButton>

    {/*
      No `capture` attribute: the Android WebView then offers a chooser with both
      the camera and the gallery. Setting `capture` replaces that chooser with a
      bare camera intent, which also disables multi-select.
    */}
    <input
      type="file"
      accept="image/*"
      multiple
      onChange={handleFileUpload}
      style={{ display: 'none' }}
    />
  </label>
</div>
  );
};

export default ImageToStruct;